exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".i-copyright {\n  flex: 0 0 auto;\n}\n.i-copyright-hidden {\n  display: none;\n}\n", ""]);

// exports
